import axios from "../../utils/axios";

export const get_all_clients = async (searchPayload = {}) => {
    const params = new URLSearchParams();
    if (searchPayload.query) {
        params.append("query", searchPayload.query);
    }
    const response = await axios.get(`/admin/clients?${params.toString()}`);
    return response.data;
};

export const search_clients = async (query) => {
    const response = await axios.get(`/admin/clients/search?q=${encodeURIComponent(query)}`);
    return response.data;
};

export const get_client = async (id) => {
    const response = await axios.get(`/admin/clients/${id}`);
    return response.data;
};

export const get_client_summary = async (id) => {
    const response = await axios.get(`/admin/clients/${id}/summary`);
    return response.data;
};

export const create_client = async (data) => {
    const response = await axios.post("/admin/clients", data);
    return response.data;
};

export const update_client = async (id, data) => {
    const response = await axios.put(`/admin/clients/${id}`, data);
    return response.data;
};

export const delete_client = async (id) => {
    const response = await axios.delete(`/admin/clients/${id}`);
    return response.data;
};

export const add_client_coordinates = async (id, coordinates) => {
    const response = await axios.post(`/admin/clients/${id}/coordinates`, { coordinates });
    return response.data;
};
